var BasketEmptyView = (function (BaseView) {
	return BaseView.extend({
		el: '@basketEmpty',
		displayRoutes: ['checkout.empty'],

		afterShow: function () {

            if (window.BestSellers) {
				BestSellers.init(this.$('@bestSellers'), false);
            }

			this.setBackCallback();
		}
	});
})(BaseView);